var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6016 5C25.6016 7.20914 23.8107 9 21.6016 9C19.3924 9 17.6016 7.20914 17.6016 5C17.6016 2.79086 19.3924 0.999999 21.6016 1C23.8107 1 25.6016 2.79086 25.6016 5Z",
    stroke: "#29388E",
    strokeWidth: 1.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.1023C9 16.3114 7.20914 18.1023 5 18.1023C2.79086 18.1023 1 16.3114 1 14.1023C1 11.8932 2.79086 10.1023 5 10.1023C7.20914 10.1023 9 11.8932 9 14.1023Z",
    stroke: "#29388E",
    strokeWidth: 1.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6016 23.2046C25.6016 25.4137 23.8107 27.2046 21.6016 27.2046C19.3924 27.2046 17.6016 25.4137 17.6016 23.2046C17.6016 20.9955 19.3924 19.2046 21.6016 19.2046C23.8107 19.2046 25.6016 20.9955 25.6016 23.2046Z",
    stroke: "#29388E",
    strokeWidth: 1.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26953 15.9668L17.9008 21.6421",
    stroke: "#29388E",
    strokeWidth: 1.9375,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8878 6.8645L9.26953 12.5398",
    stroke: "#29388E",
    strokeWidth: 1.9375,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.8a1bbbb24f018d1782825ddd9714744a.svg";
export { ForwardRef as ReactComponent };